import { useState, useEffect } from "react";
import { Bank } from "../../types/banks/Bank";
import { FirestoreBankRepository } from "../../../infrastructure/repositories/BankRepository";

interface BanksMap {
  [key: string]: Bank;
}

export const useBanks = (userBanks: { bankId: string }[]) => {
  const [banks, setBanks] = useState<BanksMap>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchBanks = async () => {
      setLoading(true);
      const bankRepository = new FirestoreBankRepository();
      const fetchedBanks: BanksMap = {};

      try {
        for (const userBank of userBanks) {
          if (!fetchedBanks[userBank.bankId]) {
            const bank = await bankRepository.getBankById(userBank.bankId);
            if (bank) {
              fetchedBanks[bank.institution_id] = bank;
            }
          }
        }
        setBanks(fetchedBanks);
      } catch (err) {
        setError(err as Error);
        console.error("Error fetching banks:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userBanks && userBanks.length > 0) {
      fetchBanks();
    } else {
      setLoading(false);
    }
  }, [userBanks]);

  return { banks, loading, error };
};
